//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscHeadsetFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 19.33L5.51 20.15L10.25 17.42L7.9 12H4.52C4.52 11.77 4.52 11.53 4.52 11.28C4.5516 9.32436 5.35617 7.46072 6.75782 6.09655C8.15947 4.73237 10.0442 3.97859 12 3.99999C13.9592 3.97326 15.8491 4.72466 17.2551 6.08941C18.6611 7.45415 19.4684 9.32085 19.5 11.28C19.5 11.52 19.5 11.76 19.5 12H16.11L13.72 17.42L16.72 19.13L15.46 21H11V23H16.54L19.4 18.61C20.7589 16.4055 21.4854 13.8697 21.5 11.28C21.4684 8.79043 20.4503 6.41503 18.6692 4.67522C16.8882 2.93542 14.4897 1.9733 12 1.99999C9.51035 1.9733 7.1118 2.93542 5.33075 4.67522C3.5497 6.41503 2.53164 8.79043 2.5 11.28C2.52316 14.1509 3.3928 16.9511 5 19.33Z" fill="currentColor" /></svg>;
}
export default IconMiscHeadsetFill;